import CodebookComboBox from "./CodebookComboBox";
import { useGetDrugs } from "../../redux/codebooksSlice";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

export default function DrugComboBox({ value, onChange, autocompleteProps, className }) {
    const { t } = useTranslation();

    const props = { label: t("prescriptions.Types.Drug"), freeSolo: true };
    if (autocompleteProps) Object.assign(props, autocompleteProps);

    return (
        <Fragment>
            <CodebookComboBox
                value={value}
                onChange={onChange}
                getOptionsHook={useGetDrugs}
                autocompleteProps={props}
                className={className}
            />
        </Fragment>
    );
}
